<template>
  <div>
    <template v-if="properties.length">
      <div style="text-align: center">
        <Carousel
          :title="titlePage"
          :properties="properties"
          :canOrder="true"
        />
        <button
          v-if="!reachedLimit"
          class="btn btn-personalized btn-load-more btn-primary"
          @click="getMoreProperties"
        >
          Cargar más
        </button>
      <!-- <b-pagination
        v-if="!isMobile"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        first-number
        last-number
      ></b-pagination> -->
      </div>
    </template>
    <template v-if="propertiesNotFound">
      <div style="text-align: center">
        <h3>
          Lo sentimos, no se han encontrado propiedades que se ajusten a los
          parámetros de búsqueda, puede comentarnos que es lo que está buscando
          a través de este formulario y nos pondremos en contacto con usted.
        </h3>
      </div>
      <import />
    </template>
    <template v-if="loading">
      <b-spinner class="spinner" label="Large Spinner"></b-spinner>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import Carousel from "@/components/Carousel";
import PropertyRepository from "@/repositories/PropertyRepository";
import Import from "@/components/Import";

export default {
  name: "SearchPage",
  components: {
    Carousel,
    Import,
  },
  props: {
    params: Object,
    title: String,
    metaTitle: String,
    metaDescription: String,
  },
  watch: {
    $route() {
      if (!this.silentRouteChange) {
        this.getProperties({ ...this.params, ...this.$route.query });
      } else {
        this.silentRouteChange = false;
      }
    },
  },
  data() {
    return {
      scrolledProperties: 18,
      properties: [],
      propertiesNotFound: false,
      reachedLimit: false,
      loading: false,
      silentRouteChange: false,
    };
  },
  metaInfo() {
    return {
      title: this.metaTitle + " " + process.env.VUE_APP_META_TITLE,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.metaDescription,
        },
      ],
      link: [
        {
          rel: "canonical",
          href: process.env.VUE_APP_LINK + this.$route.path,
        },
      ],
    };
  },
  created() {
    this.$meta().inject({ title: this.title });
    this.getProperties({
      ...this.params,
      ...this.$route.query,
      offset: this.properties.length,
      limit:
        parseInt(this.$route.query.offset ? this.$route.query.offset : "0") +
        this.scrolledProperties,
    }).then(() => {
      const lastRef = sessionStorage.getItem("lastRef");
      const lastCard = document.getElementById(`card-ref-${lastRef}`);
      if (lastRef && lastCard && this.$route.query.offset) {
        lastCard.scrollIntoView();
      }
    });
  },
  computed: {
    actualParams: function() {
      return { ...this.params, ...this.$route.query };
    },
    titlePage: function() {
      if (this.actualParams.propertyType) {
        return Vue.filter("parsePropertyForTitle")(
          this.actualParams.propertyType
        );
      } else if (this.title) {
        return this.title;
      } else {
        return "Resultados de la Búsqueda";
      }
    },
    isMobile: function() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    async getProperties(params, scroll = false) {
      this.loading = true;
      if (
        this.$route.query.offset != params.offset &&
        this.properties.length > 0
      ) {
        this.silentRouteChange = true;
        this.$router.push({
          query: { ...this.$route.query, offset: params.offset },
        });
      }

      const { data } = await PropertyRepository.search(params);
      if (data.length < this.scrolledProperties) {
        this.reachedLimit = true;
      }
      this.properties = scroll ? this.properties.concat(data) : data;

      this.propertiesNotFound = !this.properties.length;
      this.loading = false;
    },
    getMoreProperties() {
      if (!this.loading && !this.reachedLimit) {
        const lastPropertyPosition = this.properties.length - 1;
        this.getProperties(
          {
            ...this.actualParams,
            offset: this.properties.length,
            limit: this.scrolledProperties,
          },
          true
        ).then(() => {
          const lastCard = document.getElementById(
            `card-ref-${this.properties[lastPropertyPosition].intReference}`
          );
          if (lastCard) {
            lastCard.scrollIntoView();
          }
        });
      }
    },
  },
};
</script>

<style>
.not-found-text {
  margin-top: 200px;
}
@media (max-width: 767px) {
  .not-found-text {
    margin-top: 0px;
    margin-bottom: 50px;
  }
}
.btn-load-more {
  border: 3px solid #0085ca !important;
  margin-bottom: 15px;
}
</style>
